import React from 'react';
import {
  Text as DefaultText,
} from '@uncinc/uncinc-react-kitchen-sink';

import { customElementHandler } from '../WysiwygField';

const Text = ({ ...props }) => (
  <DefaultText
    textProps={{
      customElementHandler,
    }}
    {...props}
  />
);

export default Text;
